export default {
  'approvers.title': 'Approvers Configuration',
  'approvers.level': 'Approval Level',
  'approvers.dynamicEntity': 'Dynamic Entity',
  'approvers.dynamicEntityField': 'Field',
  'approvers.fieldData': 'Value',
  'approvers.area': 'Area',
  'approvers.entityValue': 'Entity Value',

  'approvers.userGroup.title': 'Manage Global Approvers by User Group',
  'approvers.userGroupPosition.title': 'Manage Global Approvers by User Group and Position',
  'approvers.dynamicEntityUser.title': 'Manage Global Approvers by Entities and Users',
  'approvers.dynamicEntityUserGroup.title': 'Manage Global Approvers by Entities and User Groups',
  'approvers.dynamicEntityPosition.title': 'Manage Global Approvers by Entities and Positions',

  'approvers.globalArea.title': 'Manage Global Approvers by User Group and Area',

  'approvers.entityArea.title': 'Manage Global Approvers by Entity and Area',
};
